<a class="link d-flex flex-row flex-sm-column"
  [ngClass]="{'item-content-disabled': resource.isUnresolved}"
  [routerLink]="resource.isUnresolved ? null : ['/search', 'card']"
  [queryParams]="{id: resource.id, entityType: resource.entityType}"
  data-automation-id="link-to-resource-page"
  [attr.data-focus-id]="'id' + index">
  <div class="image-container d-flex align-items-start align-items-sm-end">
    <app-cover
      [config]="resource.coverConfig"
      [title]="resource.title"
      [author]="resource.author?.label"
      data-automation-id="resource-image"
      size="medium">
    </app-cover>
  </div>
  <div class="item-details-container ml-4 ml-sm-0">
    <div class="item-title mt-sm-6" *ngIf="resource.title">
      <div class="cdk-visually-hidden">{{ resource.title }}</div>
      <span class="item-title line-clamp line-clamp--three"
            [tippy]="resource.title"
            data-automation-id="resource-title"
            [attr.aria-hidden]="true"
      >{{ resource.title }}</span>
    </div>
    <div class="author mt-3" *ngIf="resource.author?.label">
      <div class="cdk-visually-hidden">{{ resource.author.label }}</div>
      <span
        class="line-clamp line-clamp--three"
        data-automation-id="resource-author"
        [tippy]="resource.author?.label"
        [attr.aria-hidden]="true"
      >{{ resource.author.label }}</span>
    </div>
    <div *ngIf="resource.date"
         class="publication-date mt-1"
         data-automation-id="resource-publication-date"
    >{{ resource.date }}</div>
  </div>
</a>
